import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CwSpinner } from '@bbraun/cortex-angular';

@Component({
  selector: 'app-sidebar-heartbeat',
  imports: [
    CwSpinner
  ],
  templateUrl: './sidebar-heartbeat.component.html',
  styleUrl: './sidebar-heartbeat.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarHeartbeatComponent {
  public isLoading = input.required<boolean>();
}
